const formFieldsValidationTemplate = (inputs) => {
  const formFieldsValidationTemplateObject = {};
  inputs?.map((ic) => {
    switch (ic.__component) {
      case "forms.hidden-field":
        formFieldsValidationTemplateObject[ic?.name] = {
          valid: true,
          message: "",
        };
        break;
      case "forms.form-item":
        formFieldsValidationTemplateObject[ic?.name] = {
          required: ic?.required,
          value: ic?.value,
          type: "text",
          valid: true,
          message: "",
          validation: ic?.validation,
        };
        break;
      case "forms.textarea-field":
        formFieldsValidationTemplateObject[ic?.name] = {
          required: ic?.required,
          valid: true,
          type: "textarea",
          message: "",
        };
        break;
      case "forms.choice-field-item":
        formFieldsValidationTemplateObject[ic?.name] = {
          required: ic?.required,
          valid: true,
          type: "select",
          message: "",
        };
        break;
      case "forms.radio-field":
        formFieldsValidationTemplateObject[ic?.name] = {
          required: ic?.required,
          type: "radio",
          valid: true,
          message: "",
        };
        break;
      case "forms.checkbox":
        formFieldsValidationTemplateObject[ic?.name] = {
          required: ic?.required,
          valid: true,
          type: "checkbox",
          message: "",
        };
        break;
      case "forms.email-field":
        formFieldsValidationTemplateObject[ic?.name] = {
          required: ic?.required,
          type: "email",
          valid: true,
          message: "",
        };
        break;
      case "forms.captcha-field":
        formFieldsValidationTemplateObject[ic?.name] = {
          required: true,
          value: "",
          type: "recaptcha",
          valid: true,
          message: "",
        };
        break;
      case "forms.signature":
        formFieldsValidationTemplateObject[ic?.name] = {
          required: ic?.required,
          value: "",
          type: "signature",
          valid: true,
          message: "",
        };
        break;
      default:
    }
  });

  return formFieldsValidationTemplateObject;
};

export default formFieldsValidationTemplate;
